import { render, staticRenderFns } from "./PartidaFormImplicado.vue?vue&type=template&id=a2030cc6"
import script from "./PartidaFormImplicado.vue?vue&type=script&lang=js"
export * from "./PartidaFormImplicado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports